import React from 'react'
import { useSelector } from 'react-redux'

import { selectFullscreen } from '@store/actionSlices/appConfig'

import {
  CloseSvg,
  EyeSlashSvg,
  EyeSvg,
  FullScreenSvg,
  StopCompareSvg,
} from '@svg/react'

interface ControlsProps {
  showPropertyInfo: boolean
  onStopComparison: () => void
  onFullScreenToggle: (status: boolean) => void
  onPropertyInfoToggle: (status: boolean) => void
}

function Controls({
  showPropertyInfo,
  onStopComparison,
  onFullScreenToggle,
  onPropertyInfoToggle,
}: ControlsProps) {
  const fullscreen = useSelector(selectFullscreen)
  return (
    <div className="flex items-center justify-between text-xs font-semibold tracking-widest text-white">
      <button
        type="button"
        onClick={() => onFullScreenToggle(!fullscreen)}
        className="rounded bg-[#747474] p-2"
      >
        {fullscreen ? (
          <CloseSvg className="h-6 w-6 text-white" />
        ) : (
          <FullScreenSvg className="h-6 w-6 text-white" />
        )}
      </button>
      <div className="flex gap-4">
        <button
          type="button"
          onClick={() => onPropertyInfoToggle(!showPropertyInfo)}
          className="inline-flex items-center rounded bg-[#747474] px-3 py-1 uppercase"
        >
          {showPropertyInfo ? (
            <>
              <EyeSlashSvg className="mr-1 h-4 w-4" /> Hide Info
            </>
          ) : (
            <>
              <EyeSvg className="mr-1 h-4 w-4" /> Show Info
            </>
          )}
        </button>
        <button
          type="button"
          className="inline-flex items-center rounded bg-[#747474] px-3 py-1 uppercase"
          onClick={onStopComparison}
        >
          <StopCompareSvg
            className="mr-1 h-4 w-4 fill-white stroke-white"
            stroke={1.6}
          />
          Stop Comparing
        </button>
      </div>
    </div>
  )
}

export default Controls
